import { FunctionComponent } from 'react';

import { Button, Checkbox, GroupForm, Link, Text, Textinput } from '@/atoms';
import { ButtonVariant } from '@/atoms/button/types';
import { LinkVariant } from '@/atoms/link/types';

import { TypeEvaluationFormProps } from './types';
import MoonLoader from 'react-spinners/MoonLoader';

/**
 * EvaluationForm
 */
export const EvaluationForm: FunctionComponent<TypeEvaluationFormProps> = ({
  className = '',
  title,
  backgroundColor,
  textButton,
  nameLabel,
  emailLabel,
  labelCkeckDown,
  children,
  textLink,
  urlLink,
  onClickLink,
  textUrlMobile,
  textLinkMobile,
  onClickLinkMobile,
  valueInformationPolicy,
  valueEvaluationPolicy,
  isSubmitting,
}: TypeEvaluationFormProps) => (
  <div
    style={{ backgroundColor: backgroundColor }}
    className={`flex flex-col ${className}`}
  >
    <p className="text-subtitle text-subtitle--l mb-6">{title}</p>
    <div className="mb-4 w-full">
      <Textinput
        label={nameLabel}
        name="nameAndLastName"
        className="mb-2 w-full md:min-w-56 focus:color-primary-500 active:color-primary-500"
        placeholder="Nombre y Apellidos"
      />
    </div>
    <div className="mb-4 w-full">
      <Textinput
        label={emailLabel}
        name="emailEvaluation"
        type="email"
        className="mb-2 w-full md:min-w-56 focus:color-primary-500 active:color-primary-500"
        placeholder="ejemplo@gmail.com"
      />
    </div>
    <div className="text-text-secondary">
      <GroupForm name="evaluationPolicy">
        <Checkbox name="evaluationPolicy" value="acepto-politica" checked={valueEvaluationPolicy}>
          {children}
        </Checkbox>
      </GroupForm>
    </div>
    <Text className="text-body text-body--s text-text-secondary my-6 text-justify">
      Campofrio Food Group, S.A.U (CFG), tratará los datos personales facilitados con la finalidad de gestionar el presente proyecto de trazabilidad sobre productos de marca Navidul con base en nuestro interés legítimo, así como, en el caso de que el usuario consienta, para proceder al envío de comunicaciones comerciales sobre nuestros propios productos con base a dicho consentimiento. Puede ejercitar sus derechos de protección de datos y contactar con nuestro Delegado de Protección de Datos en <Link href="mailto:dpo.external@campofriofg.com" className="text-primary-500 hover:text-primary-600 normal-case !text-xs">dpo.external@campofriofg.com</Link>. Consulte información detallada en nuestra <Link href="/es/politica-privacidad" className="text-primary-500 hover:text-primary-600 normal-case !text-xs">Política de Privacidad</Link>.
    </Text>
    <div className="mb-6 text-text-secondary">
      <Checkbox name="informationPolicy" value="acepto-informacion" checked={valueInformationPolicy}>
        {labelCkeckDown}
      </Checkbox>
    </div>
    <p className="text-body text-body--s my-4">
      Este sitio está protegido por reCAPTCHA.
    </p>
    {isSubmitting ?
      <div className="flex justify-center">
        <MoonLoader color="#c78938" loading={true} speedMultiplier={0.6} className="spinner" />
      </div>
      :
      <Button type="submit" variant={ButtonVariant.PRIMARY} disabled={isSubmitting}>
        {textButton}
      </Button>
    }
    <Link
      href={textUrlMobile}
      className="lg:hidden mt-7"
      icon="left"
      variant={LinkVariant.POSITIVE}
      onClick={onClickLinkMobile}
    >
      {textLinkMobile}
    </Link>
    <Link
      href={urlLink}
      className="hidden lg:flex mt-7"
      variant={LinkVariant.POSITIVE}
      onClick={onClickLink}
    >
      {textLink}
    </Link>
  </div>
);

EvaluationForm.displayName = 'EvaluationForm';
